<script>
import draggable from "vuedraggable";
import api from "@/plugins/api";
import core from "@/core";

export default {
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    loading: false,
    items: [],
    items2: [],
    checkMove: false,
    showed:false,
  }),
  methods: {
    drop(evt) {
      if (this.items2.length > 3 && !this.showed) {
        this.showed = true;
        this.$core.notify.warning('Будут показываться только первые три метки!');
      }
      const marks = this.items2.map((item, index) => {
        return {
          MarkId: item.id,
          Priority: index + 1,
        };
      })
      this.$emit('change', marks);
    },
    // start(ev){
    //   if(this.items2.length > 3) {
    //     console.log('больше трех',this.items2.length);
    //   }
    //   console.log(ev)
    // },
    // end(ev){
    //   if(this.items2.length > 3) {
    //     console.log('больше трех',this.items2.length);
    //     return false;
    //   }
    // },
    loadItems() {
      const request = {
        name: 'tourtag',
        formatting: true,
      };
      const containsItems = this.value.map(item=>{
        return item.MarkId
      });
      return api.dictionary.list(request)
        .then((data) => {
          this.items = data.items.filter((item)=> {
            return !containsItems.some((num) => num === item.id)
           });
          this.items2 = data.items.filter((item)=> {
            return containsItems.some((num) => num === item.id)
          });
        })
        .finally(() => {
        });
    }
  },
  created() {
    this.loadItems();
  }
};
</script>
<template>
  <div class="f-c-marks">
    <div class="f-c-marks-row">
      <h4>Все метки</h4>
    <draggable class="f-c-marks-group" :list="items" group="marks" @change="drop">
      <div
        class="f-c-marks-item"
        :style="{ background: `${element.colorMark}`, color: `${element.colorText}`}"
        v-for="(element, index) in items"
        :key="element.id"
      >
        {{ element.name }}
      </div>
    </draggable>
    </div>
    <div class="f-c-marks-row">
      <h4>Метки тура</h4>
    <draggable class="f-c-marks-group" :list="items2" group="marks" @change="drop">
      <div
        class="f-c-marks-item"
        :style="{ background: `${element.colorMark}`, color: `${element.colorText}`}"
        v-for="(element, index) in items2"
        :key="element.id"
      >
        {{ element.name }}
      </div>
    </draggable>
      </div>
  </div>
</template>
<style lang="scss">
.f-c-marks {
  display: flex;
  flex-direction: row;
  &-row {
    margin-top: 15px;
    width: 45%;
    margin-left: 2.5%;
  }
  &-group {
    min-height: 30px;
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-bottom: 0;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, .525);
    flex-wrap: wrap;
  }

  &-item {
    width: auto;
    position: relative;
    display: block;
    margin: 5px;
    border: 1px solid rgba(0, 0, 0, .525);
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    padding: 5px 14px;
  }
}
</style>
